import {
  sortProducts,
  countProducts,
  findProductIndexInProducts,
  groupProductsByStore
} from "../../utils";

const state = {
  wishlist: JSON.parse(localStorage.getItem("wishlist")) || { products: [] }
};

const getters = {
  getWishlist: state => state.wishlist,

  getProductsInWishlist: state => state.wishlist.products,

  getProductsGroupedByStore: state =>
    groupProductsByStore(state.wishlist.products),

  getCountedSortedProducts: state =>
    sortProducts(countProducts(state.wishlist.products), FIELD_SORTING),
  getCountedProducts: state => countProducts(state.wishlist.products),
  isProductInWishlist: state => product =>
    getters.findProductIndexInWishlist(state)(product) > -1,

  findProductIndexInWishlist: state => product =>
    findProductIndexInProducts(product, state.wishlist.products, UNIQUE_FIELDS)
};

const actions = {
  updateWishlist() {
    localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
  },
  toggleProductInWishlist(context, product) {
    return getters.isProductInWishlist(state)(product)
      ? context.commit("removeProductFromWishlist", product)
      : context.commit("addProductToWishlist", product);
  }
};

const mutations = {
  setWishlist(state, wishlist) {
    state.wishlist = wishlist;
    actions.updateWishlist();
  },

  addProductToWishlist(state, product) {
    state.wishlist.products = [...state.wishlist.products, product];
    actions.updateWishlist();
  },
  removeProductFromWishlist(state, product) {
    const index = getters.findProductIndexInWishlist(state)(product);
    if (index !== -1) {
      state.wishlist.products.splice(index, 1);
      actions.updateWishlist();
    }
  }
};

export const UNIQUE_FIELDS = ["_id", "chosenSize", "color"];
export const FIELD_SORTING = {
  name: (a, b) => (a < b ? -1 : a > b ? 1 : 0),
  chosenSize: (a, b) => {
    const size_order = ["XS", "S", "M", "L", "XL"];
    const sizeToIndex = size => size_order.indexOf(size);
    return sizeToIndex(a) < sizeToIndex(b)
      ? -1
      : sizeToIndex(a) > sizeToIndex(b)
      ? 1
      : 0;
  },
  color: (a, b) => (a < b ? -1 : a > b ? 1 : 0)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
